import React, { useState } from "react";
import Teleport from "../Custom/Teleport";
import { addCategoryOrDeck } from "../../endpoints/FlashCards/functions";
import { Button } from "@mui/material";
import CustomTextField from "../Custom/CustomTextField";
const AddCategory = (props) => {
  const { openModal, setOpenModal } = props;
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  function toggle() {
    if (openModal === "active") {
      setOpenModal("");
      setName("");
    } else {
      setOpenModal("active");
    }
  }
  async function handleAdd(name) {
    setLoading(true);
    try {
      await addCategoryOrDeck("categories", props.token, name, null);
      setName("");
      await props.getCategories();
    } catch (error) {
      console.log("Error occured at handleAdd", error);
    }
    setLoading(false);
    setOpenModal("");
  }
  return (
    <Teleport>
      <div className={openModal} id="add-modal">
        <div className="header">
          <h1>Add Category</h1>
        </div>
        <div className="modal-body">
          <CustomTextField
            name="title"
            sx={{ width: "100%" }}
            inputProps={{ maxLength: 50 }}
            value={name}
            color="black"
            type="text"
            label="Name"
            onChange={(e) => setName(e.target.value)}
            onKeyDownCapture={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleAdd(name);
              }
            }}
          />
          <div className="float-actions gap-2 d-flex justify-content-center">
            <Button
              onClick={toggle}
              color="ghostBlack"
              variant="contained"
              sx={{ width: "8rem" }}
              className="py-2"
              disableElevation
            >
              Cancel
            </Button>
            <Button
              color="black"
              variant="contained"
              disableElevation
              sx={{ width: "8rem" }}
              className="py-2"
              onClick={() => handleAdd(name)}
              disabled={loading || name === ""}
            >
              {!loading ? "Add" : "Adding..."}
            </Button>
          </div>
        </div>
      </div>
      <div className={openModal} id="add-overlay"></div>
    </Teleport>
  );
};

export default AddCategory;
